import { useLocation, useParams } from 'quartz-routing/react-router';
import { useEffect } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/components/View';
import { ButtonGroup } from 'foundations-components/transitional/components/ButtonGroup';
import { ACRedirect } from 'academy-common-lib/components/ACRedirect';
import { ACRouterButton } from 'academy-common-lib/components/ACRouterButton';
import { useHasGate } from 'academy-common-lib/features/accounts/accountsQueries';
import { NavMarker } from 'react-rhumb';
import ErrorBoundary from '../../../components/Errors/ErrorBoundary';
import UsageTracker from '../../../utils/UsageTracker';
import Card from '../components/common/Card';
import ContentTable from '../components/content/ContentTable';
import ContentTableFilters from '../components/content/ContentTableFilters';
import { FiltersCard } from 'academy-common-lib/features/filters/components/FiltersCard';
import { PageHeader } from 'academy-common-lib/features/header/components/PageHeader';
import { getBreadcrumbItem } from '../constants/breadcrumbs';
import { ALL_CONTENT_PATH, ALL_PLAYLISTS_PATH, COMPLETED_CONTENT_PATH, INCOMPLETE_CONTENT_PATH } from '../constants/routes';
import { removePageParam } from '../utils/paginationUtils';
import { getContentStatus } from '../utils/contentUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const tableNames = {
  INCOMPLETE: 'contentIncomplete',
  COMPLETED: 'contentCompleted'
};
export const RedirectToContentDefaultTab = () => {
  const location = useLocation();
  const {
    hasGate,
    hasGateLoading
  } = useHasGate('AcademyAchievements::AssignAnyContentMyTeam');
  if (hasGateLoading) {
    return null;
  }
  if (hasGate === false) {
    return /*#__PURE__*/_jsx(ACRedirect, {
      to: Object.assign({}, location, {
        pathname: ALL_PLAYLISTS_PATH
      })
    });
  }
  return /*#__PURE__*/_jsx(ACRedirect, {
    to: Object.assign({}, location, {
      pathname: ALL_CONTENT_PATH
    })
  });
};
const MyTeamContent = () => {
  const {
    contentStatus
  } = useParams();
  const status = getContentStatus(contentStatus);
  const location = useLocation();
  const {
    hasGate,
    hasGateLoading
  } = useHasGate('AcademyAchievements::AssignAnyContentMyTeam');
  const tableName = status ? tableNames[status] : 'contentAll';
  const breadcrumbs = [getBreadcrumbItem({
    pageKey: 'MY_TEAM'
  }), getBreadcrumbItem({
    pageKey: 'MY_TEAM_CONTENT',
    isCurrent: true
  })];
  useEffect(() => {
    UsageTracker.track('pageView', {
      screen: 'my-team-content-page'
    });
  }, []);
  if (hasGateLoading) {
    return null;
  }
  if (hasGate === false) {
    return /*#__PURE__*/_jsx(ACRedirect, {
      to: Object.assign({}, location, {
        pathname: ALL_PLAYLISTS_PATH
      })
    });
  }
  return /*#__PURE__*/_jsx(NavMarker, {
    name: "MY_TEAM_CONTENT_PAGE_LOADED",
    children: /*#__PURE__*/_jsxs(View, {
      children: [/*#__PURE__*/_jsx(PageHeader, {
        breadcrumbs: breadcrumbs,
        subtitle: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.heading.headingSubTitles.MY_TEAM_CONTENT"
        }),
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.heading.headingTitles.MY_TEAM_CONTENT"
        })
      }), /*#__PURE__*/_jsx(FiltersCard, {
        paddingBlock: "400",
        paddingInline: "400",
        shouldRenderClearFilters: false,
        children: /*#__PURE__*/_jsxs(ButtonGroup, {
          children: [/*#__PURE__*/_jsx(ACRouterButton, {
            active: status === undefined,
            replace: true,
            to: {
              pathname: ALL_CONTENT_PATH,
              search: removePageParam(location.search)
            },
            use: "tertiary-extra-light",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "learningCenter.myTeam.content.tabs.all"
            })
          }), /*#__PURE__*/_jsx(ACRouterButton, {
            active: status === 'COMPLETED',
            replace: true,
            to: {
              pathname: COMPLETED_CONTENT_PATH,
              search: removePageParam(location.search)
            },
            use: "tertiary-extra-light",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "learningCenter.myTeam.content.tabs.completed"
            })
          }), /*#__PURE__*/_jsx(ACRouterButton, {
            active: status === 'INCOMPLETE',
            replace: true,
            to: {
              pathname: INCOMPLETE_CONTENT_PATH,
              search: removePageParam(location.search)
            },
            use: "tertiary-extra-light",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "learningCenter.myTeam.content.tabs.incomplete"
            })
          })]
        })
      }), /*#__PURE__*/_jsxs(Card, {
        children: [/*#__PURE__*/_jsx(ContentTableFilters, {
          tableName: tableName
        }), /*#__PURE__*/_jsx(ErrorBoundary, {
          boundaryName: "ContentTable",
          children: /*#__PURE__*/_jsx(ContentTable, {
            tableName: tableName
          })
        })]
      }, tableName)]
    })
  });
};
export default MyTeamContent;